<template>
  <section>
    <el-dialog title="添加子商品档案" :visible.sync="visible" width="70%">
      <div class="mod-block">
        <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form" :rules="formRule">
          <div class="groups">
            <el-form-item label="子商品编码" prop="childItem">
              <el-input v-model="form.childItem" disabled></el-input>
            </el-form-item>
            <el-form-item label="子商品名称" prop="childItemDesc" required :rules="[{validator: $validate.required}]">
              <el-input v-model="form.childItemDesc"></el-input>
            </el-form-item>
            <el-form-item label="口味商品-销售商品" prop="flavorItem" class="label-text">
              <el-select v-model="form.flavorItem" @change="changeFlavorItem">
                <el-option value="Y" label="是">是</el-option>
                <el-option value="N" label="否">否</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品条码" prop="barcode" ref="barcode">
              <el-input v-model="form.barcode" :disabled="!!form.barcodeType" @input="handleBarcode"></el-input>
            </el-form-item>
            <el-form-item label="编码类型" prop="barcodeType" ref="barcodeType">
              <el-select v-model="form.barcodeType" clearable
                :disabled="!!form.barcode || (isWeightCode && form.flavorItem === 'Y')"
                @change="barcodeTypeChange">
                <el-option value="Y" label="自编码" v-if="!(isWeightCode && form.flavorItem === 'Y')">自编码</el-option>
                <el-option value="N" label="称重码" v-else>称重码</el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save">{{index!==''?'保存':'保存并添加下一个'}}</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
  export default {
    props: ['dataList'],
    inject: ['getMod'],
    data () {
      var validateBar = (rule, value, callback) => {
        if (!this.form.barcode && !this.form.barcodeType) {
          callback(new Error("商品编码、条码类型至少填写一项"))
        } else {
          //任意值被填写，清除验证提示
          if (!this.form.barcode || !this.form.barcodeType) {
            this.$refs.barcode.clearValidate()
            this.$refs.barcodeType.clearValidate()
          }
          callback()
        }
      }
      return {
        visible: false,
        form: {
          barcode: '',
          barcodeType: '',
          childItem: '',
          childItemDesc: '',
          flavorItem: ''
        },
        formRule: {
          // barcodeType: [{ required: true, message: '请输入', trigger: 'blur' }],
          flavorItem: [{ required: true, message: '请选择', trigger: 'change' }],
          barcode: [{validator: validateBar}],
          barcodeType: [{validator: validateBar}]
        },
        isWeightCode: '',
        index: ''
      }
    },
    watch: {
      visible (val) {
        if (val) {
          let $basicInfo = this.getMod('basicInfo')
          this.isWeightCode = $basicInfo.form.standardUom === 'KG'
          if (!this.form.childItemDesc) {
            this.form.childItemDesc = $basicInfo.form.itemDesc
          }
          // 标准单位为kg，创建子商品档案，是否销售商品为是，编码类型默认为称重码
          if (this.isWeightCode && this.form.flavorItem === 'Y') {
            this.form.barcodeType = 'N'
          }
        } else {
          this.$refs.form.resetFields()
        }
      }
    },
    computed: {
    },
    methods: {
      changeFlavorItem (val) {
        if (this.form.flavorItem === 'Y' && this.isWeightCode) {
          this.form.barcode = ''
          this.form.barcodeType = 'N'
        } else {
          this.form.barcode = ''
          this.form.barcodeType = ''
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      handleBarcode (val) {
        this.form.barcodeType = ''
      },
      barcodeTypeChange () {
        this.form.barcode = ''
      },
      editROw (obj, index) {
        this.form = Object.assign({}, obj)
        this.index = index
        this.visible = true
      },
      save () {
        this.$refs.form.validate(valid => {
          if (valid) {
            let arr = this.dataList.find(item => item.flavorItem === 'Y')
            let fIndex = this.dataList.findIndex((item) => item.flavorItem === 'Y')
            // index === fIndex 编辑“口味商品-销售商品”
            if (this.index !== fIndex && arr && this.form.flavorItem === 'Y') {
              this.$message.warning('已存在口味商品-销售商品为“是”的数据，不允许重复添加!')
              return
            }
            if (typeof this.index === 'number') {
              this.visible = false
              this.$emit('sure', {...this.form, index: this.index})
              this.index = ''
            } else {
              this.$emit('sure', {...this.form})
            }
            this.$message.success('操作成功')
            this.$refs.form.resetFields()
          }
        })
      }
    },
    mounted () {
      // let $basicInfo = this.getMod('basicInfo')
      // $basicInfo.$on('updated', () => {
      //   this.isWeightCode = $basicInfo.form.standardUom === 'KG'
      // })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 0px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    .groups {
      overflow: hidden;
      padding-bottom: 10px;
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/taste/sub-commodity-add.vue